module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAA8ElEQVQoU3WQMU7DQBBF37fFDShzgTR0VBArBUnBARByhLgBdW5AT02FwhZIXAAhhHDo6JA4AA0NPQXsDrLXMQ4LW+3OvJl5s6J3zBXHwGkTsjDXbHnRz2v1sMV4QOZfQW3MAp6Bjqq3FfMDu51dyKt+J/AjlY/LFL4i56t4BoZRw17YqLZ0gE/gJu/Gm5h/QjLItlXev//p3Llfjm7ru2bV3roSdM4d7IqbBi4fpglsrpiDtUXKwE6wmtZZ/X+xoNE6l7nCMAvRk/x3t+4d/H6ExSGBT8T1v7CFSYThLo5UslRX3MIfKF10bYJheE2/AcZ9WJMwpJwjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/route/simulation.png
// module id = CW1+
// module chunks = 2